module.exports = __webpack_public_path__ + "static/media/logo-ies.2a32af64.svg";